/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useMemo } from 'react';
import { Platform as RNPlatform } from 'react-native';
import { useDeviceInfo } from '@airasia-rn/ui'; // usage of your existing package
import type { Platform } from '../models/homepageBlockTypes';

/**
 * Returns the current platform type required by the Homepage Service.
 * Logic:
 * - Native iOS  -> 'ios'
 * - Native Android -> 'android'
 * - Web (Mobile UserAgent OR Small Screen) -> 'web-mobile'
 * - Web (Desktop) -> 'web'
 */
export function usePlatform(): Platform {
  const { isWeb, isMobileWidth } = useDeviceInfo();

  return useMemo(() => {
    if (!isWeb) return RNPlatform.OS === 'ios' ? 'ios' : 'android';
    return isMobileWidth ? 'web-mobile' : 'web';
  }, [isWeb, isMobileWidth]);
}
